<template>
    <component :class="classList" :is="tag" v-on="$listeners">
        <slot></slot>
    </component>
</template>

<script>
export default {
    name: "VFlex",
    props: {
        tag: {
            type: String,
            default: "div"
        },
        direction: {
            default: "row",
            validator: function(value) {
                return ["column", "row"].indexOf(value) !== -1;
            }
        },
        justify: String,
        align: String,
        reverse: Boolean,
        wrap: Boolean,
        stretch: Boolean
    },
    computed: {
        classList() {
            let list = ["d-flex"];

            this.direction && list.push(`flex-${this.direction}`);
            this.justify && list.push(`justify-content-${this.justify}`);
            this.align && list.push(`align-items-${this.align}`);
            this.wrap && list.push(`flex-wrap`);
            this.stretch && list.push("h-100 w-100");

            return list;
        }
    }
};
</script>